"use client"

import { cn } from "@/lib/utils"
import { UbCookiePreferencesLinkStoryblok } from "@/components/storyblok/component-types"

export default function UbCookiePreferencesLinkClient(props: { blok: UbCookiePreferencesLinkStoryblok }) {
  function showCookiePreferences(e) {
    e.preventDefault()
    window.OneTrust.ToggleInfoDisplay()
  }

  return (
    <a
      href={"#"}
      onClick={showCookiePreferences}
      className={cn("flex h-full items-center gap-2 text-sm whitespace-nowrap")}
    >
      <span className={cn("")}>{props.blok.name || ""}</span>
    </a>
  )
}
